import * as Sentry from '@sentry/react'
import 'yet-another-react-lightbox/styles.css'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import ReactDOMClient from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import { initializeDayJs } from '@localisation'
import { getPostHogClient, getPostHogConfig, initializeNetworkToken } from '@utils'
import App from './App'
import { DEFAULT_QUERY_CLIENT_OPTIONS } from '@query/queryClientOptions'
import { restoreAndSubscribeDashboardPersistence } from '@query'
import { PostHogProvider } from '@posthog/react'
import { usePostHogCookiebotConsent } from '@hooks'

initializeDayJs()
initializeNetworkToken()
const postHogClient = getPostHogClient()
const { isAnalyticsProd } = getPostHogConfig()

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 0.4,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true',
  release: process.env.SENTRY_RELEASE // Defined in vite.config.mts
})

const queryClient = new QueryClient({
  defaultOptions: DEFAULT_QUERY_CLIENT_OPTIONS
})

const container = document.getElementById('root')
if (!container) {
  throw new Error('Failed to find root element')
}
const root = ReactDOMClient.createRoot(container)

const PostHogConsentGate = ({ isAnalyticsProd }: { isAnalyticsProd: boolean }) => {
  usePostHogCookiebotConsent(isAnalyticsProd)
  return null
}

const mount = () => {
  root.render(
    <QueryClientProvider client={queryClient}>
      <DndProvider backend={HTML5Backend}>
        <PostHogProvider client={postHogClient}>
          <PostHogConsentGate isAnalyticsProd={isAnalyticsProd} />
          <App />
        </PostHogProvider>
      </DndProvider>
    </QueryClientProvider>
  )
}

void restoreAndSubscribeDashboardPersistence(queryClient).then(mount, mount)
